<template>
  <div class="resultados">
    <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" />
    <table>
      <thead>
        <tr>
          <th>Texto da Pergunta</th>
          <th>Status (Ativo)</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="pergunta in perguntas" :key="pergunta.id">
          <td data-label="Texto:">
            <span>{{ pergunta.texto }}</span>
          </td>
          <td data-label="Ativo:">
            <span>{{ pergunta.ativo ? 'Sim' : 'Não' }}</span>
          </td>
          <td class='coluna-acoes'>
            <div class="coluna-acoes-tabela">
              <div class="icone-tabela">
                <router-link :to="{ name: 'PerguntaShow', params: { id: pergunta.id } }">
                  <img src="../../assets/imagens/icon-view.svg" alt="Visualizar" title="Visualizar" />
                </router-link>
              </div>
              <div v-if="podeEscrever('perguntas')" class="icone-tabela">
                <router-link :to="{ name: 'PerguntaEdit', params: { id: pergunta.id } }">
                  <img src="../../assets/imagens/icon-edit.svg" alt="Editar" title="Editar" />
                </router-link>
              </div>
              <span v-if="podeEscrever('perguntas')" class="icone-tabela" type="button" @click="opcoesExcluir(pergunta.id)">
                <img src="../../assets/imagens/icon-delete-preto.svg" alt="Excluir" title="Excluir" />
              </span>
            </div>
          </td>
          <div class="modal-exclusao" :id="pergunta.id">
            <div class="modal-mask">
              <div class="modal-container">
                <div class="modal-header">
                  <h2>Deseja mesmo excluir esta Pergunta?</h2>
                </div>
                <div class="modal-body">
                  <p>Dados da Pergunta:</p>
                  <div class="dados">
                    <div class="texto-centralizado">
                      Texto: <span>{{ pergunta.texto }}</span>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button class="btn-confirmar-exclusao" @click="excluirLinha(pergunta.id)">Sim</button>
                  <button class="btn-cancelar-exclusao" @click="opcoesExcluir(pergunta.id)">Não</button>
                </div>
              </div>
            </div>
          </div>
        </tr>
        <tr v-if="!perguntas || perguntas.length === 0" class="sem-resultados">
            <td colspan="3"><p><b>Nenhum Resultado Encontrado</b></p></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import MsgErroFormularios from "../MsgErroFormularios";
  import PerguntaApi from "../../services/PerguntaApi";

  export default {
    name: "TabelaResultadosPerguntas",
    props: {
      perguntas: Array,
    },
    components: {
      MsgErroFormularios,
    },
    data() {
      return {
        msgErros: {
          pergunta: '',
        },
        erro: false,
      };
    },
    created() {
      this.perguntaApi = new PerguntaApi();
    },
    methods: {
      opcoesExcluir(perguntaId) {
        let modalExclusao = document.getElementsByClassName('modal-exclusao');
        for (let i = 0; i < modalExclusao.length; i++) {
          if (modalExclusao[i].id == perguntaId) {
            if (modalExclusao[i].style.visibility !== "visible") {
              modalExclusao[i].style.visibility = "visible";
            } else {
              modalExclusao[i].style.visibility = "hidden";
            }
          }
        }
      },
      
      async excluirLinha(perguntaId) {
        this.opcoesExcluir(perguntaId);
        try {
          this.erro = false;
          await this.perguntaApi.destroyPergunta(perguntaId);
          window.location.reload();
        } catch (err) {
          this.erro = true;
          this.msgErros.pergunta = "Não foi possível excluir a pergunta , pois ela está vinculada a um Formulário.";
          console.error(err);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @media screen and (min-width: "1066px") {
    .resultados {
      table {
        tbody {
          tr {
            td {
              padding: 1rem .7rem;
              vertical-align: middle;
              text-align: center;
            }

            td:nth-child(1) {
              min-width: 9rem;
              padding: .9rem;
              text-align: left;
            }
          
            td:nth-child(2) {
              text-align: center;
            }            

            td:nth-child(3) {
              text-align: left;
            }

            td:nth-child(4) {
              text-align: left;
            }

            td:nth-child(5) {
              text-align: left;
              max-width: 50rem;
            }
          }

          .coluna-acoes-tabela {
            
            text-align-last: center;

            .icone-tabela {
              width: fit-content;
              display: inline-block;
              background-color: #fff;
              margin: 0 .05rem 0 .05rem;
            }
          }
        }
      }
    }
  }
  .modal-exclusao {
    visibility: hidden;
  }
  .texto-centralizado {
    text-align: center;
    margin-bottom: 0.5rem;
  }
</style>